import classNames from 'classnames'
import * as React from 'react'

import {makeEditable} from '@/common/utils'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Image from '@/components/Image'
import Link from '@/components/Link'

const LogosFiltered = ({headingTag, heading, content, items, _editable}) => {
  const HeadingTag = headingTag || 'p'
  const categoryList = items.reduce((acc, item) => {
    if (item.category && !acc.includes(item.category)) {
      acc.push(item.category)
    }
    return acc
  }, [])

  const [selectedCategory, setSelectedCategory] = React.useState('All')

  return (
    <section {...makeEditable(_editable)} className='py-16 lg:py-22'>
      <Grid>
        <div className='col-span-full flex flex-col justify-center text-purple-900 lg:col-start-3 lg:col-end-11'>
          <HeadingTag>
            <Heading heading={heading} size='m' theme='dark' className='text-center lg:mb-6' />
          </HeadingTag>

          <Content content={content} className='mb-0 mt-1 flex justify-center text-center' />
          <div className='flex -translate-y-2 justify-center'>
            <svg
              width='230'
              height='48'
              viewBox='0 0 230 48'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clip-path='url(#clip0_3100_19851)'>
                <path
                  d='M2.5114 10.6203C56.3861 10.3424 110.019 9.66441 164.037 9.61993C184.831 9.6028 205.66 9.80162 226.659 10.3038C233.538 10.4683 223.031 10.9186 221.456 11.0737C197.123 13.4696 170.57 14.885 145.2 16.5895C139.114 16.9984 2.77162 26.1388 27.3294 26.009C66.2548 25.8031 169.169 24.9371 208.424 25.3303C249.085 23.1997 154.825 39.0731 137.377 44.0182'
                  stroke='#7F6AFF'
                  stroke-width='2'
                  stroke-linecap='round'
                />
              </g>
              <defs>
                <clipPath id='clip0_3100_19851'>
                  <rect width='230' height='48' fill='white' />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div className='col-span-full mt-12 flex flex-wrap justify-center gap-2 md:col-start-1 md:col-end-7 lg:col-start-3 lg:col-end-11'>
          <div
            className={classNames(
              'misc-button-m cursor-pointer rounded-xl bg-violet-200 px-4 py-2 uppercase transition-all duration-300 lg:px-6 lg:py-3',
              {
                'bg-violey-700 text-white': selectedCategory === 'All',
                'bg-violet-200 ': selectedCategory !== 'All',
              }
            )}
            onClick={() => setSelectedCategory('All')}
          >
            All
          </div>
          {categoryList.map((category) => {
            return (
              <div
                key={category}
                className={classNames(
                  'misc-button-m cursor-pointer whitespace-nowrap rounded-xl px-4 py-2 uppercase transition-all duration-300 lg:px-6 lg:py-3',
                  {
                    'bg-violey-700 text-white': selectedCategory === category,
                    'bg-violet-200 ': selectedCategory !== category,
                  }
                )}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </div>
            )
          })}
        </div>
        <div className='col-span-full mt-10 grid grid-cols-2 gap-8 md:grid-cols-9 md:gap-4 lg:mt-20 lg:grid-cols-12'>
          {items.map((item) => {
            return (
              <div
                key={'logos' + item.id}
                className={classNames('span-1 flex-col md:col-span-3 lg:col-span-2', {
                  flex: item.category === selectedCategory || selectedCategory === 'All',
                  hidden: item.category !== selectedCategory && selectedCategory !== 'All',
                })}
              >
                {item.link ? (
                  <Link link={item.link} className='body-xl-bold'>
                    <Image
                      {...makeEditable(_editable)}
                      {...item.logo}
                      sizes={{sm: 33, md: 20}}
                      fitIn
                      ratio='176:64'
                      className='m-auto'
                    />
                  </Link>
                ) : (
                  <Image
                    {...makeEditable(_editable)}
                    {...item.logo}
                    sizes={{sm: 33, md: 20}}
                    fitIn
                    ratio='176:64'
                    className='m-auto'
                  />
                )}
              </div>
            )
          })}
        </div>
      </Grid>
    </section>
  )
}

export default LogosFiltered
